import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { arrayIsDefinedAndContainsKey } from '../shared/array-functions';
import { CONSTANTS } from '../shared/constants';

@Injectable()
export class PaymentsService {
  private apiUrl: string;
  public paymentHistoryList: object[];
  public emptyPaymentHistoryList: boolean;

  constructor(private http: HttpClient) { 
    this.apiUrl = environment.api.protocol + environment.api.hostname + environment.api.path;
    this.emptyPaymentHistoryList = false;
  }

  /* 
   * Get list of payments records of a subscription
   * API endpoint: /HistoryPaymentList?SubID=subscriptionId
  */
  getPaymentHistoryList(subscriptionId) {
    this.paymentHistoryList = undefined;
    this.emptyPaymentHistoryList = false;
    const route = 'HistoryPaymentList';
    return this.http.get(this.apiUrl + route + '?' + CONSTANTS.api.subscriptionIdQueryParam + '=' + subscriptionId).subscribe(
      (data) => {
        if (arrayIsDefinedAndContainsKey(data, 'CMS_SAM_Get_PaymentHistoryList_BySubID')) {
          this.paymentHistoryList = data['CMS_SAM_Get_PaymentHistoryList_BySubID'];
        } else {
          this.emptyPaymentHistoryList = true;
        }
      },
      (err: HttpErrorResponse) => {
        this.handleError(err);
    });
  }

  /* 
   * Get details of a payment record
   * API endpoint: /PaymentHistoryDetail?SubID=subscriptionId&EpaymentID=ePaymentId
  */
  getPaymentDetails(subscriptionId, ePaymentId) {
    const route = 'PaymentHistoryDetail';
    return this.http.get(this.apiUrl + route + '?' + CONSTANTS.api.subscriptionIdQueryParam + '=' + subscriptionId + '&' + CONSTANTS.api.ePaymentIdQueryParam + '=' + ePaymentId)
    .map((res: Response) => { 
        return res; 
    }).catch((error: any) => 
      Observable.throw(error || 'Server error')
    );
  }

  /*
   * Submit a payment
   * API endpoint: /MakePayment
   * Request Payload: SubID, PaymentMethodID, Amount
  */
  submitPayment(subscriptionID, paymentMethodId, amount): Observable<any> {
    const route = 'MakePayment';
    const payload = {
      SubID: subscriptionID,
      PaymentMethodID: paymentMethodId,
      Amount: amount
    };  
    return this.http.put(this.apiUrl + route, payload)
    .map((res: Response) => { 
      return res; 
    }).catch((error: any) => 
      Observable.throw(error || 'Server error')
    );
  }

  /*
    * Get Customer Billing Address by Payment Method
    * API endpoint: CustomerBillingAddress?PaymentMethodID=paymentMethodId
  */
  getBillingAddressByPaymentMethodId(paymentMethodId) {
    const route = 'CustomerBillingAddress';
    return this.http.get(this.apiUrl + route + '?' + CONSTANTS.api.paymentMethodIdQueryParam + '=' + paymentMethodId)
    .map((res: Response) => { 
      return res; 
    }).catch((error: any) => 
      Observable.throw(error || 'Server error')
    );
  }

  public edgilProcessResultResponse = {
    success: 'Sucessfull',
    decline: 'Decline',
    notCompleted: ['PaymentMethodCouldNotBeFound', 'EpaymentRecordCoulNotBeCreated', 'SubscriptionCouldNotBeFound', 'EdgilResponseCouldNotBeReceived', 'CheckNumberIsRequired', 'NotProcessed', 'Unknown']
  };
  
  private handleError(err:HttpErrorResponse){
    if (err.error instanceof Error) {
      // A client-side or network error occurred
      console.log('An error occurred:', err.error.message);
    } else {
      // The backend returned an unsuccessful response code
      console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/services/payments-service.ts